// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_2KGR9","profileName":"_2P3AK","profile":"_3A_-d","search":"_2Qmag"};